import { render, staticRenderFns } from "./PersonalAreaAccordion.vue?vue&type=template&id=6fa0163a&scoped=true&"
import script from "./PersonalAreaAccordion.vue?vue&type=script&lang=js&"
export * from "./PersonalAreaAccordion.vue?vue&type=script&lang=js&"
import style0 from "./PersonalAreaAccordion.vue?vue&type=style&index=0&id=6fa0163a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa0163a",
  null
  
)

export default component.exports